module.exports = __webpack_public_path__ + "static/media/26.b6865238.png";